<div (window:resize)="onResize()"></div>
<!-- Reset default -->
<li class="nav-item">
  <a (click)="onBtnResetDefaultTableView()" class="nav-link link-sidebar">
    <i class="material-icons">login</i>
    <span class="hidden-md-down" ui-test-id="resetDefaultSystemViewBtn">
      {{ 'TABLE_VIEW_RESET_TABLE_VIEW_SYSTEM_DEFAULT' | translate }}
    </span>
  </a>
</li>
